export * from './coming-soon/coming-soon.module';
export * from './open-science/open-science.module';